export default "__VITE_ASSET__CjUMhDOv__"